import { lazy } from "react";

import { LoginWithSSO } from "views/login-with-sso";

import type { RouteConfig } from "../types";
import { RequireLoginRedirect } from "../redirects";

const ForgotPassword = lazy(() => import("views/forgot-password"));
const SignUpView = lazy(() => import("views/sign-up"));
const Login = lazy(() => import("views/login"));

export const getUnauthRoutes = (): RouteConfig[] => [
  { path: "/forgot-password", component: ForgotPassword },
  { path: "/sign-up", component: SignUpView },
  { path: "/login", component: Login },
  { path: "/login-with-sso", component: LoginWithSSO },
  { path: "*", component: RequireLoginRedirect }
];
